// extracted by mini-css-extract-plugin
export default {"name":"name_name__Vbm2V"};